import { PageLoading } from 'module/ui/components/atoms/loading';
import { Outlet } from '@rocketlane/rocket-router';
import { useCompanyFromUrl } from './use-current-company';

export const AccountDetailPage = () => {
  const { data: company, isLoading: isCompanyLoading } = useCompanyFromUrl();

  return isCompanyLoading ? (
    <PageLoading />
  ) : company == null ? (
    <></>
  ) : (
    <Outlet />
  );
};
